<template>
  <Header />
  <!-- <canvas ref="canvasRef" class="fullscreen"></canvas> -->
  <div class="test">
    <div class="content-container">
      <div class="content">
        <div class="content-detail">
          <h1>内製化支援トレーナー</h1>
          <p>
            PoC
            レベルの開発が進められるようになることを目標として、フロント、バックエンド、インフラの範囲までトレーニングを提供しています。
          </p>
          <p>
            軽量な Web アプリを Flask で作成し、Vue.js を用いて SPA
            化した後、バックエンドを Lambda
            で動かすといったように、アプリのサーバーレス化まで焦点を当ててトレーニングを行なっています。
          </p>
        </div>
      </div>
      <div class="content">
        <div class="content-detail">
          <h1>フロントエンド開発</h1>
          <p>
            自社サービスのフロントエンド開発を行なっています。詳細はより力と経験を得てから追記。
          </p>
          <p>個人開発に関しては Personal Activity をご覧ください。</p>
        </div>
      </div>
      <div class="content">
        <div class="content-detail">
          <h1>バックエンド開発</h1>
          <p>
            自社サービスのバックエンド開発を行なっています。詳細はより力と経験を得てから追記。
          </p>
          <p>個人開発に関しては Personal Activity をご覧ください。</p>
        </div>
      </div>
    </div>
  </div>
  <Footer />
</template>


<script>
import * as THREE from "three";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { TextGeometry } from "three/examples/jsm/geometries/TextGeometry.js";
import { FontLoader } from "three/examples/jsm/loaders/FontLoader.js";
// import font from "@/assets/fonts/helvetiker_regular.typeface.json"

export default {
  components: {
    Header,
    Footer,
  },

  data() {
    /**
     * non-reactiveなデータ
     * * https://stackoverflow.com/a/54907413
     */
    this.scene = null;
    this.camera = null;
    this.renderer = null;
    this.cube = null;
    this.ambientLight = null;
    this.directionalLight = null;

    /**
     * reactiveなデータ
     * * ここでThree.jsのデータを定義すると、重くなるか動かなくなるので注意
     *   * https://stackoverflow.com/a/65732553
     */
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  },

  mounted() {
    this.init();
    this.addBox();
    this.animate();
    this.addLight();
    this.addText();
    window.addEventListener("resize", this.handleResize);
    console.log(this.scene);
  },

  // beforeUnmount: function () {
  //   window.removeEventListener('resize', this.handleResize)
  // },

  methods: {
    handleResize() {
      this.width = window.innerWidth;
      this.camera.aspect = this.width / this.height;
      this.camera.updateProjectionMatrix();
      // Update renderer
      this.renderer.setSize(this.width, this.height);
      this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    },

    init() {
      this.scene = new THREE.Scene();
      this.camera = new THREE.PerspectiveCamera(
        75, // FOV
        window.innerWidth / window.innerHeight, // aspect ratio
        0.2, // near
        1000 // far
      );
      this.renderer = new THREE.WebGLRenderer({
        canvas: this.$refs.canvasRef,
        alpha: true,
      });
      // this.renderer = new THREE.WebGLRenderer({ canvas: this.$refs.canvasRef })

      // レンダリング解像度
      this.renderer.setSize(window.innerWidth, window.innerHeight, false);

      this.camera.position.z = 5;
    },

    addBox() {
      // const geometry = new THREE.BoxGeometry(1, 1, 1)
      const geometry = new THREE.OctahedronGeometry(1, 0);
      // const geometry = new THREE.SphereGeometry( 1, 13, 7 );

      // const material = new THREE.MeshBasicMaterial({ color: 0xffffff })
      const material = new THREE.MeshStandardMaterial({ color: 0x2c3e50 });
      material.roughness = 0.5;
      material.metalness = 0.3;
      this.cube = new THREE.Mesh(geometry, material);
      this.cube.rotation.x = Math.PI / 26;
      // this.cube.position.x = -1
      // this.scene.add(this.cube);
    },

    animate() {
      // requestAnimationFrame(this.animate)

      // this.cube.rotation.x += 0.01
      // this.cube.rotation.y += 0.01

      // this.renderer.render(this.scene, this.camera)

      const clock = new THREE.Clock();
      const tick = () => {
        const elapsedTime = clock.getElapsedTime();
        // console.log(elapsedTime)

        // this.cube.rotation.x += 0.01
        const period = 10;
        this.cube.rotation.y = (2 * Math.PI * elapsedTime) / 10;
        this.cube.position.x =
          (1 / 4) * Math.sin(2 * (Math.PI / period) * elapsedTime);
        this.cube.position.y =
          (1 / 8) * Math.sin(2 * 2 * (Math.PI / period) * elapsedTime);

        // Render
        this.renderer.render(this.scene, this.camera);

        // Call tick again on the next frame
        window.requestAnimationFrame(tick);
      };

      tick();
    },

    addLight() {
      this.ambientLight = new THREE.AmbientLight(0xffffff, 0.9);
      this.directionalLight = new THREE.DirectionalLight(0xffffff, 0.9);
      const helper = new THREE.DirectionalLightHelper(this.directionalLight, 1);

      this.scene.add(this.ambientLight, this.directionalLight);
      // this.scene.add( helper );
    },

    addText() {
      const fontLoader = new FontLoader();

      fontLoader.load("fonts/helvetiker_regular.typeface.json", (font) => {
        const textGeometry = new TextGeometry("Training", {
          font: font,
          size: 1,
          height: 0.2,
          curveSegments: 12,
          bevelEnabled: true,
          bevelThickness: 0.03,
          bevelSize: 0.02,
          bevelOffset: 0,
          bevelSegments: 5,
        });
        textGeometry.center();
        const textMaterial = new THREE.MeshBasicMaterial({ color: "blue" });
        const text = new THREE.Mesh(textGeometry, textMaterial);
        this.scene.add(text);
      });
    },
  },
};
</script>

<style scoped>
.fullscreen {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: -1;
}

/* .test {
  height: 2000px;
  margin-top: 100vh;
} */

.content-container {
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-evenly; */
}

.content {
  width: 50%;
  margin: 50px 0;
}

.content-detail {
  padding: 10px 100px;
}

.content-detail p {
  text-align: left;
}
</style>